export const loadProductionPurchaseOrdersPage = () => import('../modules/production-operations/pages/PurchaseOrdersPage');
export const loadProductionOverviewPage = () => import('../modules/production-operations/pages/OverviewPage');
export const loadProductionProductsBomPage = () => import('../modules/production-operations/pages/ProductsBomPage');
export const loadProductionMaterialInventoryPage = () =>
  import('../modules/production-operations/pages/MaterialInventoryPage');
export const loadProductionSemiFinishedPage = () =>
  import('../modules/production-operations/pages/SemiFinishedPage');
export const loadProductionOrdersPage = () => import('../modules/production-operations/pages/OrdersKanbanPage');
export const loadProductionReportsPage = () => import('../modules/production-operations/pages/ReportsTracePage');

export function preloadProductionRoutes() {
  return Promise.all([
    loadProductionOverviewPage(),
    loadProductionProductsBomPage(),
    loadProductionMaterialInventoryPage(),
    loadProductionSemiFinishedPage(),
    loadProductionOrdersPage(),
    loadProductionReportsPage(),
  ]);
}
